import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { withFragments } from '@sorare/core/src/lib/gql';

import type { cardsScoreCount_anyCardInterface } from './__generated__/utils.graphql';

export const cardsScoreCount = withFragments(
  (cards: Nullable<cardsScoreCount_anyCardInterface[]>) => {
    return (
      cards?.reduce(
        (acc, card) =>
          acc + (card.cardCollectionCards.at(0)?.scoreBreakdown?.total || 0),
        0
      ) || 0
    );
  },
  {
    anyCardInterface: gql`
      fragment cardsScoreCount_anyCardInterface on AnyCardInterface {
        slug
        cardCollectionCards {
          id
          scoreBreakdown {
            total
          }
        }
      }
    ` as TypedDocumentNode<cardsScoreCount_anyCardInterface>,
  }
);
